import { render } from "./Biblioteca.vue?vue&type=template&id=90e27632&scoped=true"
import script from "./Biblioteca.vue?vue&type=script&lang=js"
export * from "./Biblioteca.vue?vue&type=script&lang=js"

import "./Biblioteca.vue?vue&type=style&index=0&id=90e27632&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e27632"]])

export default __exports__